// import React, { useEffect, useState } from 'react'
// import Navbar from './components/Navbar'
// import Sidebar from './components/Sidebar'
// import { Route, Routes } from 'react-router-dom'

// import Add from './pages/Add'
// import List from './pages/List'
// import Orders from './pages/Orders'
// import Login from './components/Login'

// import {ToastContainer} from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// export const backendUrl = process.env.REACT_APP_BACKEND_URL;

// const App = () => {

//   const [token, setToken] = useState(localStorage.getItem('token')?localStorage.getItem('token'):'');

//   useEffect(()=>{
//     localStorage.setItem('token',token);
//   },[token])

//   return (
//     <div>
//       <ToastContainer />
//       {token === "" ? <Login setToken ={setToken} /> : <>
//         <Navbar setToken={setToken}/>
//         <hr/>
//         <Sidebar/>
//         <div>
//           <Routes>
//             <Route path='/add' element={<Add  token={token} />}/>
//             <Route path='/list' element={<List token={token}/>}/>
//             <Route path='/orders' element={<Orders token={token}/>}/>
//           </Routes>

//         </div>
//         </>
//       }
//     </div>
//   )
// }

// export default App




import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import { Route, Routes } from 'react-router-dom';
import Add from './pages/Add';
import List from './pages/List';
import Orders from './pages/Orders';
import Login from './components/Login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const currency = '$';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');

  useEffect(() => {
    localStorage.setItem('token', token);
  }, [token]);

  return (
    <div>
      <ToastContainer />
      {token === "" ? (
        <Login setToken={setToken} />
      ) : (
        <>
          <Navbar setToken={setToken} />
          <hr />
          {/* Flex container to keep Sidebar and Content Side-by-Side */}
          <div className="d-flex gap-4 m-2">
            <Sidebar />
            <div className="flex-grow-1 p-3"> {/* Ensures content takes remaining space */}
              <Routes>
                <Route path="/add" element={<Add token={token} />} />
                <Route path="/list" element={<List token={token} />} />
                <Route path="/orders" element={<Orders token={token} />} />
              </Routes>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default App;


